import { format } from "date-fns";

export const getStartDateMax = (_endDate?: string): string | undefined => {
    return undefined;
};

export const getEndDateMin = (startDate?: string): string | undefined => {
    if (!startDate) return undefined;
    try {
        return format(new Date(startDate), "yyyy-MM-dd");
    } catch {
        return undefined;
    }
};
